import React, {useState} from "react";
import Notify from "../../services/Notify";
import {Button, Col, Row} from "react-bootstrap";
import {ModalMessage} from "../../component/Modal/ModalMessage";
import {MobileApplicationsService} from "../../services/MobileApplicationsService";
import {dayMonthYearAtTimeWithSeconds} from "../../utils/dates";

class MobileApplicationsDetailType {

  actionsButtons = (row, reloadGrid) => {

    const [show, setShow] = useState(false)

    const deleteItem = async () => {
      try {
        await new MobileApplicationsService().deleteById(row.original.id)
        Notify.success('Aplicativo deletado com sucesso!')
      } catch (error) {
        Notify.error('Erro ao excluir aplicativo', error)
      } finally {
        setShow(false)
        reloadGrid && reloadGrid()
      }
    }
    return (
      <Row className="d-flex align-items-center justify-content-around flex-row">
        <Col md={6}>
          <Button block bsStyle="secondary" href={`#/dash/mobile-applications/edit/${row.original.id}`}>Editar</Button>
        </Col>
        <Col md={6}>
          <Button block bsStyle="danger" onClick={() => setShow(true)}>Excluir</Button>
        </Col>
        <ModalMessage
          showModal={show}
          handleShowModal={setShow}
          title="Deseja exluir o aplicativo?"
          successButtonAction={deleteItem}/>
      </Row>
    )
  }
  getColumns = () => {
    return [
      {
        Header: 'Nome do aplicativo',
        accessor: 'friendlyName',
        style:{textAlign: "center"},
      },
      {
        Header: 'Identificador',
        accessor: 'identifier',
        style:{textAlign: "center"},
      },
      {
        Header: 'Android',
        accessor: 'android.currentVersion',
        style:{textAlign: "center"},
      },
      {
        Header: 'Ios',
        accessor: 'ios.currentVersion',
        style:{textAlign: "center"},
      },
      {
        Header: 'Ùltima modificação',
        accessor: 'updatedAt',
        style:{textAlign: "center"},
        Cell: row => row.original && dayMonthYearAtTimeWithSeconds(row.original.updatedAt)
      },
      {
        Header: "Ações",
        sortable: false,
        filterable: false,
        export: false,
        Cell: row => this.actionsButtons(row, this.forceReload)
      }
    ]
  }
  endpoint = () => `cloud/v1/apps?deleted=false`
}
export default MobileApplicationsDetailType;



// WEBPACK FOOTER //
// ./src/pages/MobileApplications/MobileApplicationsDetailType.js